import React from "react";
import Link from "next/link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import { useTheme } from "@mui/material";

import { sliceString } from "@packages/common/src/utils/utils";

import RichTextRenderer from "../../../common/components/rich-text-renderer/RichTextRenderer";
import { NSApps } from "../types";
import { PAGE_SIZE } from "../../utils/constants";
import { neutral } from "../../../common/config/colors";

const AppsList: React.FC<{
  apps: NSApps.IAppsResponse;
  page?: number;
  handleLoadPage?: (e: any, pageNum: number) => void;
}> = ({ apps, page, handleLoadPage }) => {
  const theme = useTheme();
  const count = !!apps?.count ? Math.ceil(apps?.count / PAGE_SIZE) : undefined;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 4,
          [theme.breakpoints.down("xl")]: { justifyContent: "center" },
          "& a": {
            textDecoration: "none",
          },
        }}
      >
        {apps?.results?.map((app) => (
          <Link key={app.slug} href={`/apps/${app.slug}`}>
            <a>
              <Box
                sx={{
                  bgcolor: neutral["A500"],
                  border: "1px solid rgba(0, 0, 0, 0.22)",
                  borderRadius: 2.5,
                  py: 7,
                  px: 6,
                  width: 309,
                  height: 200,
                  "&:hover": {
                    border: "none",
                    boxShadow: "0px 6px 18px 0px #D7D7D7",
                  },
                }}
              >
                <Box height={110}>
                  <Typography variant="h5">
                    {sliceString(`${app.name}`, 50)}
                  </Typography>
                  <Box py={2} color="text.primary">
                    <RichTextRenderer
                      richTextHtml={sliceString(app.description, 65)}
                    />
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  sx={{ borderRadius: 5, minWidth: 72, height: 34 }}
                >
                  TRY IT
                </Button>
              </Box>
            </a>
          </Link>
        ))}
      </Box>
      {count &&
        apps?.count > PAGE_SIZE &&
        page &&
        typeof handleLoadPage !== "undefined" && (
          <Box py={12} px={6} display="flex" justifyContent="center">
            <Pagination
              count={count}
              page={page}
              color="primary"
              onChange={handleLoadPage}
            />
          </Box>
        )}
    </>
  );
};

export default AppsList;
